import {CHATBOT_MESSAGES_ROLES} from '../const';

export const getMessageAuthorName = (message, profile, assistants) => {
  if (message.role === CHATBOT_MESSAGES_ROLES.user) {
    return profile?.givenName;
  }
  const assistant = assistants.find(a => a.id === message.assistant_id);
  return assistant?.name || 'Unknown Assistant';
};
